<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <i class="fa fa-bullhorn"></i> {{ $t('promotions') }}
        </h1>
      </div>
    </div>
    <promotion-list/>
  </main>
</template>

<script>
import PromotionList from "./PromotionList";

export default {
  components: {PromotionList},
  data: function () {
    return {}
  },
  i18n: {
    messages: {
      en: {
        promotions: 'Promotions',
      },
      vi: {
        promotions: 'Chương trình khuyến mãi',
      }
    }
  },
};
</script>